<h3>Agents Roles</h3>

<table class="table">
	<thead class="table-dark">
		<tr>
			<th>Role</th>
			<th>Linked</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let role of wrappers">
			<td>{{role.role.name}}</td>
			<td class="text-center">
				<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="role.checked" name="permission_{{role.role.id}}" (change)="change()"/>
			</td>
		</tr>
	</tbody>
</table>
<div class="row" *hasPermission="['RoleEdit']">
	<div class="col">
		<button class="btn btn-success float-end" (click)="doSubmit()">Save</button>
	</div>
</div>



<app-permission [viewOnly]="true"></app-permission>
